import { useEffect, useRef, useState } from 'react';

/** Foto responsiva (srcset) com fade-in ao carregar. */
export const Photo = ({ photo, sizes = '100vw', className = '', priority = false, eager = false, alt, style, ...rest }) => {
  const ref = useRef(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (ref.current?.complete && ref.current.naturalWidth > 0) setLoaded(true);
  }, []);

  return (
    <img
      ref={ref}
      src={photo.lg}
      srcSet={photo.srcSet}
      sizes={sizes}
      alt={alt ?? photo.alt}
      loading={priority || eager ? 'eager' : 'lazy'}
      fetchPriority={priority ? 'high' : undefined}
      decoding="async"
      draggable={false}
      onLoad={() => setLoaded(true)}
      className={`transition-opacity duration-700 ${loaded ? 'opacity-100' : 'opacity-0'} ${className}`}
      style={style}
      {...rest}
    />
  );
};

export default Photo;
